/* eslint-disable react/prop-types */
import React, { useEffect, useState, useRef } from 'react';
import {
  Button,
  Form,
  Modal,
  notification,
  Select,
  Spin,
  Tooltip,
  Typography,
  Upload,
  Skeleton,
  Row,
  Col,
  Checkbox,
  Radio,
  Input,
  DatePicker,
} from 'antd';
import {
  PlusOutlined,
  EyeOutlined,
  MoreOutlined,
  UploadOutlined,
  CloudUploadOutlined,
  FileTextOutlined,
  CloseCircleOutlined,
  CloseOutlined,
} from '@ant-design/icons';
import { ChevronDown } from 'lucide-react';
import moment from 'moment';
import { Button as CrcButton } from '@crc-evans/ui-components';
import DocEquipmentTypes from '../../components/admin/DocEquipmentTypes';
import AddNewEquipmentType from '../../components/admin/AddNewEquipmentType';
import { connect } from 'react-redux';
import { get } from 'lodash';
import {
  fetchAdminEquipTypes,
  fetchAdminPihEquipTypes,
} from '../../redux/admin/equipmentTypes/action';
import { uploadEquipmentfile } from '../../redux/admin/upload/action';
import { fetchEquipCategory } from '../../redux/pihEquipmentDetails/action';
import {
  fetchAdminEquipSno,
  addDocumentType,
  fetchAdminEquipDocType,
  fetchAdminEquipDocList,
  fetchAdminEquipCategory,
  fetchAdminDocumentSubTypeSno,
} from '../../redux/admin/equipmentSno/action';
import { getExportDataListFromDatabase } from '../../redux/admin/equipmentTypes/saga';
import '../technical/HeatProfilePage.css';
import '../../components/admin/AddNewEquipmentType.css';
import './EquipmentSubCategory.css';

const stopTagEvent = (e) => {
  e.preventDefault();
  e.stopPropagation();
};

/** Add Document modal: serial multiselect chips with visible, accessible remove (overrides default tag styling) */
const adminDocSerialSelectTagRender = (props) => {
  const { label, closable, onClose } = props;
  return (
    <span
      className="admin-doc-serial-tag"
      onMouseDown={stopTagEvent}
    >
      <span
        className="admin-doc-serial-tag__text"
        title={typeof label === 'string' ? label : undefined}
      >
        {label}
      </span>
      {closable && (
        <span
          className="admin-doc-serial-tag__close"
          onClick={onClose}
          onMouseDown={stopTagEvent}
          role="button"
          tabIndex={-1}
          aria-label="Remove serial number"
        >
          <CloseOutlined />
        </span>
      )}
    </span>
  );
};

const { Text, Title } = Typography;
const { Option } = Select;

/** Maximum number of files user can upload at a time (document upload) */
const MAX_DOCUMENT_FILES = 15;

const EquipmentSubCategory = (props) => {
  const {
    adminEquipTypesLoading,
    adminEquipTypes,
    onGetPihEquipmentTypes,
    onUploadEquipmentFiles,
    isUploadLoading,
    //
    isEquipDetailsLoading,
    adminEquipSnoLoading,
    categoryData,
    onGetCategory,
    adminEquipSnoData,
    onGetEquipSno,
    onAddDocumentType,
    isDocumentUploadLoading,
    onFetchAdminEquipDocType,
    adminEquipDocTypeLoad,
    adminEquipDocTypeData,
    onFetchAdminEquipDocList,
    //
    onFetchAdminEquipCategory,
    adminEquipCategoryData,
    adminEquipCategoryLoad,
    //
    onFetchAdminDocumentSubTypeSno,
    adminDocumentSubCategoryLoad,
    adminDocumentSubTypeSnoData,
    //
  } = props;

  // Maitencance types
  const [checkOpen, setChecksOpen] = useState(false);
  const [openPage, setOpenPage] = useState('');

  //equipment Types
  const [equipTypeForm] = Form.useForm();
  const [equipTypeSearchForm] = Form.useForm();

  const [openModal, setOpenModel] = useState(false);
  const [equipTypeList, setEquipTypeList] = useState([]);
  const [equipTypeListDrop, setEquipTypeListDrop] = useState([]);
  const [clear, setClear] = useState(false);
  const [paginationClear, setPaginationClear] = useState(false);
  const [equipmentType, setEquipmentType] = useState('');
  const [editModelValue, setEditModelValue] = useState('');
  const [editRecord, setEditRecord] = useState('');

  /** List of selected files: { uid, name, file } for display + remove; file is the raw File for upload */
  const [fileListItems, setFileListItems] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [openUploadModal, setOpenUploadModal] = useState(false);
  const [isEquipmentModalVisible, setIsEquipmentModalVisible] = useState(false);
  const [equipTitle, setEquipTitle] = useState('');
  const [disableTypes, setDisableTypes] = useState(false);
  const [serialNoList, setSerialNoList] = useState([]);
  const [equipmentFormData] = Form.useForm();
  const [pihEquipment, setPihEquipment] = useState('');
  const [disableFileUpload, setDisableFileUpload] = useState(false);
  const [categoryDataList, setCategoryDataList] = useState([]);
  const [adminEquipmentTypes, setAdminEquipmentTypes] = useState([]);
  const [adminEquipTypeId, setAdminEquipTypeId] = useState();
  const [adminEquipSnoId, setAdminEquipSnoId] = useState();
  const [certificateUpload, setCertificateUpload] = useState(false);
  const [serialNo, setSerialNo] = useState('');
  const [pihCategory, setPihCategory] = useState('');
  const [selectedEquipment, setSelectedEquipment] = useState(true);
  const [documentBase64, setDocumentBase64] = useState('');
  const [documentId, setDocumentId] = useState('1');
  const [equipmentSubTypeId, setEquipmentSubTypeId] = useState();
  const [loadingDocList, setLoadingDocList] = useState(false);
  const [subCategoryPageActive, setSubCategoryPageActive] = useState(false);
  const [documentPageActive, setDocumentPageActive] = useState(false);
  const [reminderList, setReminderList] = useState([]);
  const [expirationDate, setExpirationDate] = useState(null);
  const [selectedDocumentType, setSelectedDocumentType] = useState('');
  const [isSubmittingDocument, setIsSubmittingDocument] = useState(false);
  const [fileListError, setFileListError] = useState('');

  const [searchCriteria, setSearchCriteria] = useState('');
  const [EquipmentDataList, setEquipmentDataList] = useState([]);
  const [searchType, setSearchType] = useState(null);
  const [searchFilterType, setSearchFilterType] = useState('');

  /** Getting Equipment Types data on load */
  useEffect(() => {
    // onGetPihEquipmentTypes({
    //     pageSize: 10,
    //     pageNumber: 1
    // });
    //onFetchAdminEquipCategory();
    onGetCategory();
    onFetchAdminEquipDocType();
  }, []);

  useEffect(() => {
    (async () => {
      const list = await getExportDataListFromDatabase();

      if (list && list.rows.length > 0) setEquipmentDataList(list.rows);
    })();
  }, []);

  /** Setting the equipment type values to the state */
  useEffect(() => {
    setEquipTypeList(adminEquipTypes);
    // setEquipTypeListDrop(adminEquipCategoryData);
  }, [adminEquipTypes]);

  // /** Setting the equipment sub category */
  // useEffect(() => {
  //     // setAdminEquipmentTypes(adminDocumentSubTypeSnoData);
  // }, [adminDocumentSubTypeSnoData])

  const RemoveDuplicates = (arr, key) => {
    return [...new Map(arr.map((item) => [item[key], item])).values()];
  };

  /** Function to make category list in alphabetical order */
  const titleCase = (str) => {
    if (str !== null) {
      var splitStr = str.toLowerCase().split(' ');
      for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      // Directly return the joined string
      var stringUpperLowerCase = splitStr.join(' ');

      //After joining the string making string to uppercase which are enclosed in brases ()
      const result = capitalCase(stringUpperLowerCase);

      return result;
    } else {
      return str;
    }
  };

  const capitalCase = (str) => {
    const result = str
      .split(' ')
      .map((s) =>
        s.startsWith('(') && s.endsWith(')')
          ? s.toUpperCase()
          : s.slice(0, 1).toUpperCase() + s.slice(1)
      )
      .join(' ');
    return result;
  };

  function setCategoryDataFunc(categoryData) {
    var arr = RemoveDuplicates(categoryData, 'pihEquipmentTypeCategory');

    var filteredArr = arr.filter(function (el) {
      return el.pihEquipmentTypeCategory != null;
    });

    //make array of category in alphabetical order
    filteredArr.sort((a, b) =>
      a.pihEquipmentTypeCategory
        .toLowerCase()
        .localeCompare(b.pihEquipmentTypeCategory.toLowerCase())
    );

    //making array Camel Case and string which are enclosed in brases () to UPPERCASE
    for (let i = 0; i < filteredArr.length; i++) {
      filteredArr[i].category = titleCase(filteredArr[i].pihEquipmentTypeCategory);
    }

    setCategoryDataList(filteredArr);
    setEquipTypeListDrop(filteredArr);
  }
  // useEffect(() => {
  //     if (categoryData && categoryData.length > 0) {
  //         setCategoryDataFunc(categoryData);
  //     } else {
  //         setCategoryDataList([]);
  //     }

  //     console.log(categoryData)
  // }, [categoryData]);

  /** Setting Serial Number list on equipment details */
  useEffect(() => {
    function addAllOption(data) {
      const allOption = {
        id: 'ALL',
        serialNumber: 'ALL',
      };

      return [allOption, ...data];
    }
    if (adminEquipSnoData.length) {
      const updatedData = addAllOption(adminEquipSnoData);
      setSerialNoList(updatedData);
    }
  }, [adminEquipSnoData]);

  /** Setting Create new Equipment Model Open */
  const handleCreateEquip = () => {
    setOpenModel(true);
    setEditModelValue(false);
    setEditRecord('');
  };

  /** Getting Searched values from the selected equipment type */
  const onSearchEquipmentType = () => {
    equipTypeSearchForm.validateFields().then(async (data) => {
      if (data && data.equipmentType) {
        setClear(true);
        const newArray = categoryDataList.find(
          (u) => u.pihEquipmentTypeCategory === data.equipmentType
        );
        setCategoryDataList([newArray]);
        setPaginationClear(true);
      } else {
        notification.warning({
          message: 'Select Equipment Category to Search.',
        });
      }
    });
  };

  /** View clera button on select of equipment type */
  const onSelectEquipType = () => {
    setClear(true);
  };

  /** clearing selected data from equipment type dropdown */
  const OnclearEquipType = () => {
    setClear(false);
    equipTypeSearchForm.resetFields();
    setClear(false);
    setSearchCriteria('');
    setSearchFilterType('');
    setSearchType(null);
    //  setEquipTypeList(adminEquipCategoryData)
    setPaginationClear(false);
    //setCategoryDataFunc(categoryData);
  };

  /** Setting Properties for upload file (supports single or multiple, max MAX_DOCUMENT_FILES; list shows with remove) */
  const fileProps = {
    accept: '.pdf,.jpeg,.jpg,.png',
    multiple: true,
    showUploadList: {
      showRemoveIcon: true,
      showPreviewIcon: false,
      removeIcon: <CloseCircleOutlined className="admin-doc-upload-remove-icon" />,
    },
    onRemove: (removedItem) => {
      setFileListItems((prev) => {
        const next = prev.filter((item) => item.uid !== removedItem.uid);
        if (next.length < MAX_DOCUMENT_FILES) {
          setFileListError('');
        }
        return next;
      });
      setDisableFileUpload(false);
    },
    beforeUpload: (file) => {
      const allowedTypes = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
      if (!allowedTypes.includes(file.type)) {
        notification.error({
          message: 'Invalid File Type',
          description: 'Only PDF, JPEG, JPG, and PNG files are allowed.',
        });
        return Upload.LIST_IGNORE;
      }
      setFileListItems((prev) => {
        if (prev.length >= MAX_DOCUMENT_FILES) {
          setFileListError(`You can upload a maximum of ${MAX_DOCUMENT_FILES} files at a time.`);
          return prev;
        }
        setFileListError('');
        const uid = `${file.name}-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
        return [...prev, { uid, name: file.name, file }];
      });
      return false;
    },
    fileList: fileListItems.map((item) => ({
      uid: item.uid,
      name: item.name,
      status: 'done',
    })),
  };

  /** Fucntion to call upload file api and get **presigned Url to upload file to aws s3 bucket */
  const handleUploadFile = async () => {
    if (fileListItems.length > 0) {
      await onUploadEquipmentFiles(fileListItems.map((item) => item.file));
    } else {
      notification.warn({ message: 'Please select a file to upload.' });
    }
  };

  /** Removing file and closing upload window on cancel */
  const handleCancelUploadFile = () => {
    setFileListItems([]);
    setUploading(false);
    setOpenUploadModal(false);
    setDisableFileUpload(false);
  };

  useEffect(() => {
    if (!isUploadLoading) {
      setFileListItems([]);
      setUploading(false);
      setOpenUploadModal(false);
      setDisableFileUpload(false);
    }
  }, [isUploadLoading]);

  const onSearch = (value) => {
    onFetchAdminEquipCategory({ searchKey: value });
  };

  /** Show modal to add new document details (from List of Documents) */
  const showModal = () => {
    setIsEquipmentModalVisible(true);
    setDisableTypes(false);
    setEquipTitle('Add New Document');
  };

  /** Open Add Document modal with equipment type pre-filled (from inside equipment document list) */
  const openAddDocumentModalWithEquipment = async (equipmentTypeId, equipmentTypeName) => {
    setAdminEquipTypeId(equipmentTypeId);
    equipmentFormData.setFieldsValue({ pihEquipment: equipmentTypeName });
    setPihEquipment(equipmentTypeName);
    await onGetEquipSno({ pihEquipmentType: equipmentTypeName });
    setDisableTypes(false);
    setEquipTitle('Add New Document');
    setIsEquipmentModalVisible(true);
  };

  /** Cloase modal on cancel */
  const handleCancel = () => {
    setIsEquipmentModalVisible(false);
    if (subCategoryPageActive && documentPageActive) {
      equipmentFormData.resetFields(['certificate', 'serialNo', 'documentType']);
    } else if (subCategoryPageActive) {
      equipmentFormData.resetFields(['certificate', 'serialNo', 'documentType', 'pihEquipment']);
      setSerialNoList([]);
    } else {
      equipmentFormData.resetFields();
      setPihEquipment('');
      setSerialNoList([]);
    }
    equipmentFormData.resetFields();
    setPihEquipment('');
    setSerialNoList([]);
    // setEditValue(false);
    setDisableTypes(false);
    setFileListItems([]);
    setLoadingDocList(false);
    setReminderList([]);
    setExpirationDate(null);
    setSelectedDocumentType('');
    setIsSubmittingDocument(false);
    setFileListError('');
  };

  /** Close Add Document modal when upload finishes (success or failure) */
  const prevDocumentUploadLoading = useRef(false);
  useEffect(() => {
    if (prevDocumentUploadLoading.current && !isDocumentUploadLoading) {
      handleCancel();
    }
    prevDocumentUploadLoading.current = isDocumentUploadLoading;
  }, [isDocumentUploadLoading]);

  /** Function to Add or Update equipment details */
  const handleOk = () => {
    equipmentFormData.validateFields().then(async (data) => {
      if (!data.pihEquipment || !data.serialNo?.length || !data.documentType) {
        notification.warning({ message: 'Fill all the required fields!' });
        return;
      }
      if (!fileListItems || fileListItems.length === 0) {
        notification.warning({ message: 'Please select at least one file.' });
        return;
      }
      if (fileListItems.length > MAX_DOCUMENT_FILES) {
        setFileListError(`You can upload a maximum of ${MAX_DOCUMENT_FILES} files at a time.`);
        return;
      }

      if (Array.isArray(data.serialNo) && data.serialNo.includes('ALL')) {
        data.serialNo = 'ALL';
      }
      const payload = {
        equipmentIds: data.serialNo,
        equipmentTypeId: adminEquipTypeId,
        documentTypeId: data.documentType,
        documentBase64: documentBase64,
        equipmentDocTypeId: equipmentSubTypeId,
        documentDocTypeId: documentId,
        certificate: fileListItems.map((item) => item.file),
      };

      if (expirationDate) {
        payload.expirationDate = moment(expirationDate).format('YYYY-MM-DD');
      }
      if (reminderList && reminderList.length > 0) {
        payload.reminderList = reminderList.join(',');
      }

      await onAddDocumentType(payload);
    });
  };

  /** On change function to select Category */
  const onChangeCategory = async (value) => {
    equipmentFormData.resetFields(['serialNo', 'pihEquipment']);
    setSerialNo('');
    setPihEquipment('');
    setAdminEquipmentTypes([]);
    if (value) {
      setPihCategory(value);
      // await onFetchAdminDocumentSubTypeSno({ pihEquipmentTypeCategory: value });
      var equipArr =
        categoryData && categoryData.filter((item) => item.pihEquipmentTypeCategory == value);
      //remove duplicates
      var arr = RemoveDuplicates(equipArr, 'pihEquipmentType');
      arr.sort((a, b) =>
        a.pihEquipmentType.toLowerCase().localeCompare(b.pihEquipmentType.toLowerCase())
      );
      setAdminEquipmentTypes(arr);
    } else {
      setSerialNoList([]);
      setPihEquipment('');
      setSerialNo('');
      setSelectedEquipment(false);
      setPihCategory('');
      setAdminEquipmentTypes([]);
    }
  };

  /** On change function to select Equipment */
  const onChangeEquipmentType = async (value) => {
    equipmentFormData.resetFields(['serialNo']);
    setSerialNo('');
    if (value) {
      // const equipmentTypeId = adminEquipmentTypes.find(u => u.name === value);
      const equipmentTypeId = EquipmentDataList.find((u) => u.pihEquipmentType === value);
      if (equipmentTypeId) {
        setAdminEquipTypeId(equipmentTypeId?.id);
        setPihEquipment(value);
        // setSelectedEquipment(true);
        //await onGetEquipSno({ pihEquipmentTypeCategory: pihCategory, pihEquipmentType: value });
        await onGetEquipSno({ pihEquipmentType: value });
      }

      // await onGetAdminMaintenanceTypesById({ id: equipmentTypeId.id });
    } else {
      setSerialNoList([]);
      setPihEquipment('');
      setSerialNo('');
      setSelectedEquipment(false);
    }
  };

  const handleSetForm = ({ pihEquipment, pihCategory }) => {
    // if (pihCategory) {
    //     equipmentFormData.setFieldsValue({
    //         pihCategory: pihCategory,
    //     });
    //     onChangeCategory(pihCategory)
    // }
    // if (pihCategory && pihEquipment) {
    //     equipmentFormData.setFieldsValue({
    //         pihEquipment: pihEquipment, pihCategory: pihCategory,
    //     });
    //     onChangeEquipmentType(pihEquipment)
    // }
  };

  const handleSearchInputChange = (value) => {
    //  if (value != '')
    setSearchFilterType(value);
    if (searchFilterType.length == 1 || value != '') setSearchCriteria(value);
    // else
    //     setSearchCriteria('');
  };

  const handleComboboxChange = async (value) => {
    setSearchType(value);
    if (value) setSearchCriteria(value);
    else setSearchCriteria('');
  };
  const handleSearchBlur = () => {
    const isValid = EquipmentDataList.some(
      (item) => item.pihEquipmentType?.toLowerCase() === searchCriteria?.toLowerCase()
    );
    if (!isValid) {
      console.log('handleSearchBlur', isValid);
      setSearchCriteria('');
      setSearchType(undefined);
    }
  };

  const onchangechxBox = (checked, values) => {
    if (checked) {
      setReminderList(values);
    } else {
      setReminderList([]);
    }
  };

  const handleExpirationChange = (date) => {
    setExpirationDate(date);
  };

  const handleDocumentTypeChange = (value) => {
    setSelectedDocumentType(value);
    // Get the description text from the selected ID
    const selectedDocType = adminEquipDocTypeData.find((item) => item.id === value);
    const docTypeDescription = selectedDocType ? selectedDocType.description : '';

    // Reset expiration and reminder when document type changes
    if (docTypeDescription !== 'Asset Certs & Tests') {
      setExpirationDate(null);
      setReminderList([]);
    }
  };

  const docEquipmentTypesProps = {
    checkOpen,
    setChecksOpen: setChecksOpen,
    equipTypeList,
    setEquipTypeList,
    categoryDataList,
    categoryData,
    adminEquipTypesLoading: adminEquipCategoryLoad,
    setOpenModel,
    openModal,
    equipTypeForm,
    equipmentType,
    setEquipmentType,
    editModelValue,
    setEditModelValue,
    setEditRecord,
    editRecord,
    openPage,
    setOpenPage,
    equipTypeSearchForm,
    OnclearEquipType,
    clear,
    setClear,
    paginationClear,
    setPaginationClear,
    equipmentFormData,
    documentId,
    setDocumentId,
    setEquipmentSubTypeId,
    equipmentSubTypeId,
    handleSetForm,
    setDocumentPageActive,
    setSubCategoryPageActive,
    searchCriteria,
    setSearchCriteria,
    onOpenAddDocumentModal: openAddDocumentModalWithEquipment,
  };

  return (
    <div className="heat-profile-content-wrapper">
      {/* Single DocEquipmentTypes instance: toggling checkOpen used to unmount/remount a second copy and clear equipment name state. */}
      <div className={!checkOpen ? 'heat-profile-card' : undefined}>
        {!checkOpen && (
          <div className="heat-profile-list-header">
            <div className="heat-profile-header-left">
              <div className="heat-profile-icon-wrap">
                <FileTextOutlined style={{ fontSize: 22 }} />
              </div>
              <div className="heat-profile-header-content">
                <div className="heat-profile-title-row">
                  <h3 className="heat-profile-list-title">List of Documents</h3>
                </div>
                <p className="heat-profile-list-description">
                  Manage technical documentation and related files.
                </p>
              </div>
            </div>

            <div className="heat-profile-header-actions">
              <Button
                type="primary"
                icon={<PlusOutlined />}
                onClick={showModal}
                className="heat-profile-add-btn"
              >
                Add New Document
              </Button>
            </div>
          </div>
        )}
        <div>
          <DocEquipmentTypes {...docEquipmentTypesProps} />
        </div>
      </div>

      {/* Modal to create/update equipmentType */}
      <AddNewEquipmentType
        setOpenModel={setOpenModel}
        openModal={openModal}
        equipTypeForm={equipTypeForm}
        equipmentType={equipmentType}
        setEquipmentType={setEquipmentType}
        editModelValue={editModelValue}
        setEditModelValue={setEditModelValue}
        setEditRecord={setEditRecord}
        editRecord={editRecord}
      />

      <Modal
        // getContainer={false}
        width="45vw"
        className="materials-modal-modern heatprofile-modal pipeline-modal admin-doc-add-modal"
        title={equipTitle}
        centered
        visible={isEquipmentModalVisible}
        onCancel={handleCancel}
        footer={[
          <CrcButton
            key="cancel"
            label="Cancel"
            onClick={handleCancel}
            variant="tertiary"
            size="medium"
          />,
          <CrcButton
            key="apply"
            label={isDocumentUploadLoading ? 'Adding' : 'Add'}
            onClick={handleOk}
            disabled={isDocumentUploadLoading}
            variant="primary"
            size="medium"
          />,
        ]}
      >
        <div>
          <Form
            form={equipmentFormData}
            name="basic"
            layout="vertical"
            autoComplete="off"
            getcontainer={false}
          >
            <Row gutter={24}>
              {/* <Col lg={12}>
                                <Form.Item
                                    label="Equipment Category"
                                    name="pihCategory"
                                    required
                                >
                                    <Select
                                        className='client-select'
                                        placeholder='Select Category'
                                        showSearch
                                        allowClear
                                        optionFilterProp="children"
                                        onChange={onChangeCategory}
                                        disabled={disableTypes}
                                    >

                                        {EquipmentDataList && EquipmentDataList.map((item, i) =>
                                            <Option key={i} value={item && item.pihEquipmentType}>{item && item.pihEquipmentType}</Option>)}
                                    </Select>
                                </Form.Item>
                            </Col> */}
              <Col lg={12}>
                <Form.Item
                  label="Equipment Type"
                  name="pihEquipment"
                  required
                >
                  <Select
                    size="large"
                    placeholder="Select Equipment"
                    showSearch
                    allowClear
                    suffixIcon={<ChevronDown size={18} color="#6B7280" />}
                    optionFilterProp="children"
                    onChange={onChangeEquipmentType}
                    disabled={disableTypes}
                    dropdownClassName="heat-profile-select-dropdown equip-type-dropdown"
                    getPopupContainer={(trigger) => trigger.parentNode}
                  >
                    {/* {adminDocumentSubCategoryLoad && <Option key={'loading'} value={'Loading...'} />} */}
                    {EquipmentDataList &&
                      EquipmentDataList.map((item, i) => (
                        <Option
                          key={i}
                          value={item && item.pihEquipmentType}
                        >
                          {item && item.pihEquipmentType}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col lg={12}>
                <Form.Item
                  label="Equipment Serial No."
                  name="serialNo"
                  required
                >
                  <Select
                    className="admin-doc-serial-select"
                    style={{ width: '100%' }}
                    size="large"
                    placeholder="Select Sl.No."
                    optionFilterProp="children"
                    suffixIcon={<ChevronDown size={18} color="#6B7280" />}
                    mode="multiple"
                    tagRender={adminDocSerialSelectTagRender}
                    disabled={!pihEquipment}
                    dropdownClassName="heat-profile-select-dropdown"
                    getPopupContainer={(trigger) => trigger.parentNode}
                  >
                    {adminEquipSnoLoading ? (
                      <Option
                        key="loading"
                        value="Loading..."
                      >
                        Loading...
                      </Option>
                    ) : (
                      serialNoList?.map((item, i) => (
                        <Option
                          key={i}
                          value={item?.id}
                        >
                          {item?.serialNumber}
                        </Option>
                      ))
                    )}
                  </Select>
                </Form.Item>
              </Col>

              <Col lg={12}>
                <Form.Item
                  label="Document Type"
                  name="documentType"
                  required
                >
                  <Select
                    size="large"
                    placeholder="Select Document type"
                    showSearch
                    allowClear
                    suffixIcon={<ChevronDown size={18} color="#6B7280" />}
                    optionFilterProp="children"
                    onChange={handleDocumentTypeChange}
                    dropdownClassName="heat-profile-select-dropdown equip-type-dropdown"
                    getPopupContainer={(trigger) => trigger.parentNode}
                  >
                    {adminEquipDocTypeLoad && (
                      <Option
                        key={'loading'}
                        value={'Loading...'}
                      />
                    )}
                    {!adminEquipDocTypeLoad &&
                      adminEquipDocTypeData &&
                      adminEquipDocTypeData.map((item, i) => (
                        <Option
                          key={i}
                          value={item && item.id}
                        >
                          {item && item.description}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col lg={12}>
                <Form.Item
                  className="form-item-select-documents-label"
                  label={
                    <div className="admin-doc-select-documents-label-text">
                      <div className="admin-doc-select-documents-title">
                        Select Documents
                        <span className="admin-doc-required-star"> *</span>
                      </div>
                      <div className="admin-doc-select-documents-sub">
                        {`You can upload up to ${MAX_DOCUMENT_FILES} documents at a time.`}
                      </div>
                    </div>
                  }
                  name="certificate"
                  required={false}
                  rules={[{ required: true, message: 'Please select at least one file.' }]}
                  validateStatus={fileListItems.length > MAX_DOCUMENT_FILES ? 'error' : ''}
                  help={
                    fileListItems.length > MAX_DOCUMENT_FILES || fileListError
                      ? `You can upload a maximum of ${MAX_DOCUMENT_FILES} files at a time.`
                      : null
                  }
                >
                  <Upload
                    {...fileProps}
                    disabled={certificateUpload}
                    className="admin-doc-upload-wrap"
                    listType="text"
                  >
                    <div
                      className="admin-doc-upload-zone"
                      role="presentation"
                    >
                      <CloudUploadOutlined className="admin-doc-upload-icon" />
                      <div className="admin-doc-upload-text">
                        <div className="admin-doc-upload-title">Click to select files</div>
                        <div className="admin-doc-upload-hint">
                          PDF, JPEG, PNG — up to {MAX_DOCUMENT_FILES} files. Names appear below.
                        </div>
                      </div>
                    </div>
                  </Upload>
                </Form.Item>
              </Col>
            </Row>
            {(() => {
              const selectedDocType = adminEquipDocTypeData.find(
                (item) => item.id === selectedDocumentType
              );
              const docTypeDescription = selectedDocType ? selectedDocType.description : '';
              return docTypeDescription === 'Asset Certs & Tests';
            })() && (
                <Row gutter={24}>
                  <Col lg={12}>
                    <Form.Item
                      name="Expiration"
                      label="Expiration"
                    >
                      <div>
                        <DatePicker
                          value={expirationDate ? moment(expirationDate) : null}
                          onChange={handleExpirationChange}
                          format="DD-MMM-YYYY"
                          placeholder="DD-MM-YYYY"
                          style={{ width: '100%' }}
                        />
                      </div>
                    </Form.Item>
                  </Col>
                  <Col lg={12}>
                    <Form.Item>
                      <Checkbox
                        style={{ fontSize: '16px' }}
                        checked={reminderList.length > 0}
                        onChange={(e) => onchangechxBox(e.target.checked, ['90', '60', '30', '15'])}
                      >
                        Reminders{' '}
                      </Checkbox>
                      <Checkbox.Group
                        style={{ display: 'block', paddingTop: '5px' }}
                        onChange={(checkedValues) => setReminderList(checkedValues)}
                        value={reminderList}
                      >
                        <Checkbox
                          style={{ marginLeft: '20px' }}
                          value="15"
                        >
                          15 Days
                        </Checkbox>
                        <Checkbox
                          style={{ marginLeft: '20px' }}
                          value="30"
                        >
                          30 Days
                        </Checkbox>
                        <Checkbox
                          style={{ marginLeft: '20px' }}
                          value="60"
                        >
                          60 Days
                        </Checkbox>
                        <Checkbox
                          style={{ marginLeft: '20px' }}
                          value="90"
                        >
                          90 Days
                        </Checkbox>
                      </Checkbox.Group>
                    </Form.Item>
                  </Col>
                </Row>
              )}
          </Form>
        </div>
      </Modal>

      {/* Full-screen loader from presigned-url until /equipment/documents completes */}
      <Modal
        open={isDocumentUploadLoading}
        footer={null}
        closable={false}
        maskClosable={false}
        width={320}
        centered
        styles={{
          content: { backgroundColor: 'var(--ant-color-bg-elevated, #1f1f1f)' },
          body: { padding: '24px 0', backgroundColor: 'var(--ant-color-bg-elevated, #1f1f1f)' },
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <Spin size="large" />
          <div
            style={{
              marginTop: 16,
              color: 'var(--ant-color-text, rgba(255,255,255,0.85))',
              fontWeight: 500,
            }}
          >
            Uploading documents, it may take some time.
          </div>
        </div>
      </Modal>
    </div>
  );
};

const mapStateToProps = ({ adminEquipTypeReducer, uploadReducer, equip, adminEquipSnoReducer }) => {
  const adminEquipTypes = get(adminEquipTypeReducer, 'adminEquipTypes', []);
  const adminEquipTypesLoading = get(adminEquipTypeReducer, 'adminEquipTypesLoading', false);
  const isUploadLoading = get(uploadReducer, 'isUploadLoading', false);
  const isEquipDetailsLoading = get(equip, 'isEquipDetailsLoading', false);
  const adminEquipSnoLoading = get(adminEquipSnoReducer, 'adminEquipSnoLoading', false);
  const categoryData = get(equip, 'categoryData', []);
  const adminEquipSnoData = get(adminEquipSnoReducer, 'adminEquipSnoData', []);
  const adminEquipDocTypeLoad = get(adminEquipSnoReducer, 'adminEquipDocTypeLoad', false);
  const adminEquipDocTypeData = get(adminEquipSnoReducer, 'adminEquipDocTypeData', []);
  const adminEquipCategoryLoad = get(adminEquipSnoReducer, 'adminEquipCategoryLoad', false);
  const adminEquipCategoryData = get(adminEquipSnoReducer, 'adminEquipCategoryData', []);
  const adminDocumentSubCategoryLoad = get(
    adminEquipSnoReducer,
    'adminDocumentSubCategoryLoad',
    false
  );
  const adminDocumentSubTypeSnoData = get(adminEquipSnoReducer, 'adminDocumentSubTypeSnoData', []);
  const isDocumentUploadLoading = get(adminEquipSnoReducer, 'isDocumentUploadLoading', false);
  return {
    adminEquipTypes,
    adminEquipTypesLoading,
    isUploadLoading,
    isEquipDetailsLoading,
    adminEquipSnoLoading,
    categoryData,
    adminEquipSnoData,
    adminEquipDocTypeLoad,
    adminEquipDocTypeData,
    adminEquipCategoryData,
    adminEquipCategoryLoad,
    adminDocumentSubTypeSnoData,
    adminDocumentSubCategoryLoad,
    isDocumentUploadLoading,
  };
};

const mapDispatchToProps = {
  onGetPihEquipmentTypes: fetchAdminPihEquipTypes,
  onUploadEquipmentFiles: uploadEquipmentfile,
  onGetCategory: fetchEquipCategory,
  onGetEquipSno: fetchAdminEquipSno,
  onAddDocumentType: addDocumentType,
  onFetchAdminEquipDocType: fetchAdminEquipDocType,
  onFetchAdminEquipDocList: fetchAdminEquipDocList,
  onFetchAdminEquipCategory: fetchAdminEquipCategory,
  onFetchAdminDocumentSubTypeSno: fetchAdminDocumentSubTypeSno,
};

export default connect(mapStateToProps, mapDispatchToProps)(EquipmentSubCategory);
// end of file
